import SubcontractorSelect from "./subcontractor-select";

const SubcontractorFormItems = {
    Select: SubcontractorSelect,
};

export default SubcontractorFormItems;